(function () {
    const _ = require('lodash');
    const $ = require('jquery');
    const Vue = require('vue').default;
    const Bloodhound = require('bloodhound-js');
    require('typeahead.js');
    const s = window.search;

    if ($('#advanced-search').length == 0) {
        return;
    }

    // This list container is hidden on page load so we don't see the flash of
    // Vue.js template markup.
    $('#advanced-search [v-for="segment in segments"]').css('display', 'block');

    const vm = new Vue({
        el: '#advanced-search',
        data: {
            open: false,
            results: '',
            resultsOpacity: 1,
            segments: s.segments,
            properties: [],
            category: s.category.id,
            listType: s.listType.id,
            bedrooms: s.bedrooms,
            bathrooms: s.bathrooms,
            is_shared: s.is_shared,
            garages: s.garages,
            commercialType: s.commercialType,
            residentialType: s.residentialType,
            commercialTypes: s.commercialTypes,
            residentialTypes: s.residentialTypes,
            bankMandated: s.bankMandated,
            withAuctions: s.withAuctions,
            onShow: s.onShow,
            newDevelopment: s.newDevelopment,
            residential_sales_min_price: s.residentialSalesMinPrice,
            residential_sales_max_price: s.residentialSalesMaxPrice,
            residential_rental_min_price: s.residentialRentalMinPrice,
            residential_rental_max_price: s.residentialRentalMaxPrice,
            residential_auction_min_price: s.residentialAuctionMinPrice,
            residential_auction_max_price: s.residentialAuctionMaxPrice,
            commercial_sales_min_price: s.commercialSalesMinPrice,
            commercial_sales_max_price: s.commercialSalesMaxPrice,
            commercial_rental_min_price: s.commercialRentalMinPrice,
            commercial_rental_max_price: s.commercialRentalMaxPrice,
            commercial_auction_min_price: s.commercialAuctionMinPrice,
            commercial_auction_max_price: s.commercialAuctionMaxPrice,
            garden: s.garden,
            pool: s.pool,
            fireplace: s.fireplace,
            security: s.security,
            furnished: s.furnished,
            commercialSizeMin: s.commercialSizeMin,
            commercialSizeMax: s.commercialSizeMax,
        },
        watch: {
            segments: function () {
                var vm = this;
                Vue.nextTick(function () {
                    vm.count();
                });
            }
        },
        computed: {
            placeholder: function () {
                if (this.segments.length == 0) {
                    return 'Neighbourhood or ref no…';
                }
                return 'Add neighbourhood…';
            },
            disableResidentialType: function () {
                return this.residentialTypes.length > 0;
            },
            disableCommercialType: function () {
                return this.commercialTypes.length > 0;
            },
            closed: function () {
                return !this.open;
            },
            commercial: function () {
                return this.category === 1 || this.category === '1';
            },
            residential: function () {
                return this.category === 2 || this.category === '2';
            },
            sales: function () {
                return this.listType == 1;
            },
            auction: function () {
                return this.listType == 2;
            },
            rental: function () {
                return this.listType == 3;
            },
        },
        methods: {
            toggle: function (e) {
                e.preventDefault();
                this.open = !this.open;
            },
            add: function (suggestion) {
                if (suggestion.type == 'property') {
                    this.properties = [suggestion];
                    this.submit();
                } else {
                    this.segments.push(suggestion);
                }
            },
            submit: function () {
                Vue.nextTick(function () {
                    $('#advanced-search').submit();
                });
            },
            remove: function (value) {
                this.segments = _.filter(this.segments, function (segment) {
                    return segment.value !== value;
                });
            },
            count: function (e) {
                var vm = this;
                var req = $.ajax({
                    url: '/api/count?' + $('#advanced-search').serialize(),
                    method: 'GET'
                });
                vm.resultsOpacity = 0.3;
                req.fail(function (res) {
                    vm.results = '';
                    vm.resultsOpacity = 1;
                });
                req.done(function (res) {
                    vm.results = res.text;
                    vm.resultsOpacity = 1;
                });
            },
        },
    });

    vm.count();

    $('#advanced-search #more').removeAttr('style');
    $('#advanced-search #row-controls').removeAttr('style');

    const source = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            wildcard: '%QUERY',
            rateLimitWait: 100,
            url: '/api/autocomplete?q=%QUERY',
            prepare: function (query, settings) {
                settings.url = '/api/autocomplete?q=' + query + '&category=' + vm.category;
                _.each(vm.segments, function (segment) {
                    settings.url += '&segments[]=' + segment.value;
                });
                return settings;
            }
        }
    });

    var $typeahead = $('.advanced-typeahead');

    $typeahead.typeahead({
        hint: false,
        minLength: 1,
        highlight: true
    }, {
        limit: 12,
        name: 'areas',
        display: 'display',
        source: source,
        templates: {
            pending: $('template#pending').html(),
            empty: $('template#empty').html()
        }
    });

    $typeahead.bind('typeahead:select', function (e, suggestion) {
        vm.add(suggestion);
        $typeahead.typeahead('val', '');
    });

    $('.order-form [name="order"]').on('change', function (e) {
        $('#advanced-search [name="order"]').val($('.order-form [name="order"]').val());
        $('#advanced-search').submit();
    });
}());
